module.exports = __webpack_public_path__ + "static/media/masjid.e6c9a000.jpg";